import React, { useEffect, useState } from "react";
import { API_BASE } from "../../api";
import "./Admin.css";
import AdminEnrollments from "./AdminEnrollments";
import AdminTransactions from "./AdminTransactions";
import AdminOfflineEnrollments from "./AdminOfflineEnrollments";


const AdminDashboard = () => {
    const [stats, setStats] = useState(null);
    const [activeTab, setActiveTab] = useState("overview"); // overview, enrollments, transactions, offline


    useEffect(() => {
        const fetchDashboard = async () => {
            console.log("--- ADMIN DASHBOARD START ---");
            const token = localStorage.getItem("token");
            if (!token) {
                console.warn("No token found, redirecting to login");
                window.location.href = "/#/admin/login";
                return;
            }

            try {
                console.log("Fetching dashboard stats from:", `${API_BASE}/api/admin/dashboard`);
                const response = await fetch(`${API_BASE}/api/admin/dashboard`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                console.log("HTTP Response Status:", response.status);

                if (response.status === 401) {
                    console.error("Unauthorized! Token might be expired.");
                    localStorage.removeItem("token");
                    window.location.href = "/#/admin/login";
                    return;
                }

                const data = await response.json();
                console.log("Full Stats Data Received:", data);
                setStats(data);
            } catch (error) {
                console.error("CRITICAL ERROR fetching dashboard:", error);
            } finally {
                console.log("--- ADMIN DASHBOARD END ---");
            }
        };

        fetchDashboard();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        window.location.href = "/#/admin/login";
    };

    // Helper to prevent "Objects are not valid as a React child"
    // Also handles DBNull serialized as {}
    const safeRender = (val) => {
        if (val === null || val === undefined) return "-";
        if (typeof val === 'object' && Object.keys(val).length === 0) return "-";
        if (typeof val === 'object') return JSON.stringify(val);
        return val;
    };

    const formatCurrency = (val) => {
        const num = Number(val);
        return isNaN(num) ? "₹0" : `₹${num.toLocaleString()}`;
    };

    if (!stats) return (
        <div className="lora-admin-body" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <p>Loading premium experience...</p>
        </div>
    );

    return (
        <div className="lora-admin-body">
            <div className="lora-admin-container">
                <header className="lora-admin-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <img src="./images/LEARNORAMA-LOGO.png" alt="Logo" style={{ width: '60px', borderRadius: '14px', boxShadow: 'var(--shadow-md)' }} />
                        <div>
                            <h2>Dashboard</h2>
                            <p style={{ color: 'var(--text-secondary)', margin: '4px 0 0 0', fontSize: '0.95rem' }}>Welcome back to Learnorama HQ</p>
                        </div>
                    </div>
                    <button onClick={handleLogout} className="lora-admin-btn lora-admin-btn-logout">Logout</button>
                </header>

                <nav className="lora-admin-tabs">
                    <div
                        className={`lora-admin-tab ${activeTab === "overview" ? "active" : ""}`}
                        onClick={() => setActiveTab("overview")}
                        style={{ cursor: 'pointer' }}
                    >
                        Overview
                    </div>
                    <div
                        className={`lora-admin-tab ${activeTab === "enrollments" ? "active" : ""}`}
                        onClick={() => setActiveTab("enrollments")}
                        style={{ cursor: 'pointer' }}
                    >
                        Enrollments
                    </div>
                    <div
                        className={`lora-admin-tab ${activeTab === "transactions" ? "active" : ""}`}
                        onClick={() => setActiveTab("transactions")}
                        style={{ cursor: 'pointer' }}
                    >
                        Transactions
                    </div>
                    <div
                        className={`lora-admin-tab ${activeTab === "offline" ? "active" : ""}`}
                        onClick={() => setActiveTab("offline")}
                        style={{ cursor: 'pointer' }}
                    >
                        Offline Enrollments
                    </div>

                </nav>

                {activeTab === "overview" && (
                    <>
                        <div className="lora-admin-stats-grid">
                            <div className="lora-admin-glass-card lora-admin-stat-card">
                                <span className="lora-admin-stat-label">Total Enrollments</span>
                                <span className="lora-admin-stat-value">{safeRender(stats.totalEnrollments || stats.TotalEnrollments)}</span>
                                <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginTop: 'auto' }}>All time applications</div>
                            </div>
                            <div className="lora-admin-glass-card lora-admin-stat-card">
                                <span className="lora-admin-stat-label">Success Payments</span>
                                <span className="lora-admin-stat-value" style={{ color: 'var(--success)' }}>
                                    {safeRender(stats.totalPaid || stats.TotalPaid)}
                                </span>
                                <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginTop: 'auto' }}>Completed transactions</div>
                            </div>
                            <div className="lora-admin-glass-card lora-admin-stat-card">
                                <span className="lora-admin-stat-label">Pending / Initiated</span>
                                <span className="lora-admin-stat-value" style={{ color: 'var(--warning)' }}>
                                    {safeRender(stats.totalPending || stats.TotalPending)}
                                </span>
                                <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginTop: 'auto' }}>Awaiting payment</div>
                            </div>
                            <div className="lora-admin-glass-card lora-admin-stat-card">
                                <span className="lora-admin-stat-label">Total Revenue</span>
                                <span className="lora-admin-stat-value">
                                    {formatCurrency(stats.totalRevenue || stats.TotalRevenue)}
                                </span>
                                <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginTop: 'auto' }}>Net earnings</div>
                            </div>
                        </div>

                        <div className="lora-admin-glass-card" style={{ padding: '60px 30px', textAlign: 'center', background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)' }}>
                            <div style={{ fontSize: '3rem', marginBottom: '20px' }}>🚀</div>
                            <h3 style={{ margin: '0 0 10px 0', fontSize: '1.8rem', fontWeight: '700' }}>Platform Operational</h3>
                            <p style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto', lineHeight: '1.6' }}>
                                Your systems are running smoothly. Navigate through the tabs to manage student enrollments and track real-time financial transactions.
                            </p>
                        </div>
                    </>
                )}

                {activeTab === "enrollments" && (
                    <AdminEnrollments isDashboardView={true} />
                )}

                {activeTab === "transactions" && (
                    <AdminTransactions isDashboardView={true} />
                )}
                {activeTab === "offline" && (
                    <AdminOfflineEnrollments isDashboardView={true} />
                )}

            </div>
        </div>
    );
};

export default AdminDashboard;
